module.exports = __webpack_public_path__ + "static/media/filter.61cccd15.svg";